import { adaptVpcEndpointMetadata } from './adaptVNEndpoints';

export const useVNEndpointMetadata = (props) => {
  const { metadata } = props;
  return adaptVpcEndpointMetadata(metadata);
};